import api from './api';

const teamService = {
  getTeam: () => api.get('/user/team'),
  inviteMember: (email) => api.post('/user/team/invite', { email }),
  acceptInvite: (token) => api.post(`/user/team/accept/${token}`, {}),
  removeMember: (id) => api.delete(`/user/team/${id}`),
  getPendingInvite: () => api.get('/user/team/pending-invite'),
  rejectInvite: () => api.post('/user/team/reject', {}),
  updatePermissions: (id, permissions) => api.put(`/user/team/${id}/permissions`, { permissions }),
  switchToMember: (memberId) => api.post(`/user/team/switch/${memberId}`, {}),
  getActivityLogs: (params = {}) => api.get('/user/activity-logs', { params }),
};

export default teamService;
